var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('elevator',{attrs:{"modal":_vm.whichModal}}),_vm._v(" "),_c('router-view',{on:{"setComics":_vm.setComics,"openModal":_vm.openModal}}),_vm._v(" "),_c('modal',{attrs:{"which":_vm.whichModal,"comics":_vm.comics,"popups":_vm.popups},on:{"closeModal":_vm.closeModal}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ba2cd7e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 